export default __webpack_public_path__ + "static/media/640_dummy2016-fotograf04-de.60aa5ff0.png";